export default __webpack_public_path__ + "static/pool-guy-0dea9c7ab0a37c3372e387177cbd572e.jpg";